import * as Sentry from '@sentry/react';
import { takeEvery } from 'saga-ts';
import { l } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';

export function* sentry(ev: any): Generator<any, void, any> {
  const { data } = ev;
  const { err } = data ?? {};

  if (!err) return;

  if (window.location.hostname === 'localhost') {
    return;
  }

  Sentry.captureException(err);
}

// Root saga
export function* root(): Generator<any, void, any> {
  l('saga|saga.sentry listening for sentry custom event');
  const channel = customEventChannel('sentry');
  yield takeEvery(channel, sentry);
}

// Export saga
export const saga = {
  id: 'sloyd.sentry',
  type: 'bootstrap',
  root,
  trigger: {},
};
